module.exports = __webpack_public_path__ + "static/shoes-color-set-1-aba8e90a5cab4b5a8bc408ff0f1f6116.png";